<template>
  <div class="dg-module-form" v-if="amReady">
    <div class="title" v-if="formHeader">{{ this.getFormTitle }}</div>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Legal Company Name"
            name="legal_company_name"
            placeholder="Legal Company Name"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="$store.state['form_sign_up_fas_free_routes-api'].dropDownList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Corporate Type"
            name="corporate_type"
            placeholder="Corporate Type"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Full Contact Name"
            name="full_contact_name"
            placeholder="Full Contact Name"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Mobile Phone"
            name="mobile_phone"
            placeholder="Mobile Phone"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Notices Email"
            name="notices_email"
            placeholder="Notices Email"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Support Email"
            name="support_email"
            placeholder="Support Email"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Rates Email"
            name="rates_email"
            placeholder="Rates Email"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="optional"
            label="Skype ID"
            name="skype_id"
            placeholder="Skype ID"
            rules="optional"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="countriesList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Country"
            name="country"
            placeholder="Country"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Business Phone"
            name="business_phone"
            placeholder="Business Phone"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="State"
            name="state"
            placeholder="State"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="City"
            name="city"
            placeholder="city"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="Zip Code"
            name="zip"
            placeholder="Zip Code"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="23"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="Business Address"
            name="business_address"
            placeholder="Business Address"
            rules="required"></dg-text-field>
      </el-col>
   <!-- <el-row> -->
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="Assigning Code"
            name="user_code"
            placeholder="Assigning Code"
            rules="required"></dg-text-field>
      </el-col>
    <!-- </el-row> -->
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="Source IP Address"
            name="source_ip_address"
            placeholder="Separate multiple IP addresses with a comma"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="Softswitch Make and Model"
            name="softswitch"
            placeholder="softswitch Make and Model"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">
        <dg-text-field
            type="textarea"
            rows="9"
            :control="control"
            :editable="editable"
            :field_span="23"
            :label_span="24"
            :translateLabel='false'
            field_mark="optional"
            label="Notes"
            name="notes"
            placeholder="Notes"
            rules="optional"></dg-text-field>
      </el-col>
    </el-row>
   

    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-select-field
            :control="control"
            :editable="true"
            :field_span="22"
            :label_span="22"
            :options="$store.state['form_sign_up_fas_free_routes-api'].statusOptions"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Request Status"
            name="signup_request_status"
            placeholder="Corporate Type"
            rules="required"></dg-select-field>
      </el-col>
    </el-row>


    <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
      <dg-radio-field
        :control="control"
        :field_span="22"
            :label_span="22"
        :options="radioOptions"
        :translateLabel="false"
        defaultValue="on"
        field_mark="required"
        label="upload_options"
        name="upload_options"
        rules="required"></dg-radio-field>
    </el-col>
  </el-row>-->

    <el-row>
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{
              (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria')
            }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="moduleDeleteAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>

          <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel"
                     :translate="false"
                     :type="actionButtonType" fieldSize="mini"
                     v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';
import countriesList from '@/components/JavascriptCountriesObject.json'

export default {
  components: {},
  beforeMount() {
    this.countriesList = this.fromObjectToKeyValue(countriesList)
    this.getFormData()
  },
  data() {
    return {
      countriesList: [],
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
      radioOptions: [
        {
          label: 'Online',
          value: 'on',
          link_label: ''
        },
        {
          label: 'Offline',
          value: 'off',
          link_label: ''
        }
      ],
    }
  },
  methods: {
    fromObjectToKeyValue (obj) {
      let out = []
      for(let key in obj) {
        out.push({
          value: key,
          label: obj[key]
        })
      }

      return out
    },
    getFormData() {
      let promises = []
      promises.push(this.getEntityDropDownList().then())
      Promise.all(promises).then((values) => {
        this.amReady = true
        $vue.nextTick(() => {
          this.bindController()
        })
      })
    },
    ...$mapActions('form_sign_up_fas_free_routes-api', {
      getEntityDropDownList: 'getDropDownList'
    }),
    async createModule() {
      this.validateFields().then(async result => {
        if (!result) {
          this.requestErrorMessage = null;
          return
        }

        this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;


        /* Images Handleing */
        // removing files they are handled alone
        delete apiParams.data.picture
        delete apiParams.data.gallery

        this.$store.dispatch('form_sign_up_fas_free_routes-api/' + apiMethod, apiParams).then(response => {
          let entity = response.data
          this.amReady = false
          notifySuccess((apiMethod == 'update') ? 'Updated' : 'Created')


          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          console.log('catch error', error)
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {
          this.requestOn = false
        })
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>
